import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCandidateEducation, deleteCandidateEducation, fetchCandidateEducation, updateCandidateEducation } from "./EducationAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCandidateEducationAsync = createAsyncThunk(
  "candidateEducation/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchCandidateEducation();

      const resp = data.response.education;
    //   console.log("data's response", resp)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addCandidateEducationAsync = createAsyncThunk(
  "candidateEducation/add",
  async ({ newCandidateEducation}) => {
    try {
      const data = await addCandidateEducation( newCandidateEducation);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

export const deleteCandidateEducationAsync = createAsyncThunk(
    "candidateEducation/delete",
    async ({uuid}, { rejectWithValue }) => {
      try {
        await deleteCandidateEducation( uuid);
        return uuid;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const updateCandidateEducationAsync = createAsyncThunk(
    "candidateEducation/update",
    async ({ uuid, CandidateEducationData }, { rejectWithValue }) => {
      try {
        const response = await updateCandidateEducation( uuid, CandidateEducationData);
        // console.log("Response Slice", response);
        return response;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const candidateEducationSlice = createSlice({
  name: "candidateEducation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidateEducationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCandidateEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(addCandidateEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addCandidateEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add project";
      })

      .addCase(updateCandidateEducationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCandidateEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedCandidateIndex = state.data.findIndex(
            (CandidateEducationData) => CandidateEducationData.uuid === action.payload.uuid
          );
      
          if (updatedCandidateIndex !== -1) {
            state.data[updatedCandidateIndex] = action.payload;
          }
        } else {
          state.data = [action.payload]; // Fallback: set the state to an array with the updated project
        }
      })
      
      .addCase(updateCandidateEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update education";
      })
      .addCase(deleteCandidateEducationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCandidateEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure state.data is an array before filtering
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((education) => education.uuid !== action.payload);
        } else {
          console.error("state.data is not an array");
        }
      })
      .addCase(deleteCandidateEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectCandidateEducation = (state) => state.candidateEducation.data;

export default candidateEducationSlice.reducer;
